const videoRichSearch = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  name: "장례식 비용, 얼마나 들까요? 장례식 비용 완벽 분석",
  description:
    "장례식을 치르는데 드는 비용은 상조 회사, 장례식장, 그리고 장지 비용, 이렇게 3개로 나눌 수 있습니다. 그리고 각 항목에는 굉장히 많은 종류의 서비스와 용품이 포함되어 있는데요, 합리적인 비용으로 장례식을 치르기 위해서는 이에 대해 잘 알고 계시는 것이 좋습니다.",
  thumbnailUrl: [
    "https://example.com/photos/1x1/photo.jpg",
    "https://example.com/photos/4x3/photo.jpg",
    "https://example.com/photos/16x9/photo.jpg",
  ],
  uploadDate: "2022-05-31T08:00:00+08:00",
  duration: "PT5M55S",
  contentUrl: "https://www.youtube.com/watch?v=oQoEu-1gk18",
  embedUrl: "https://www.youtube.com/embed/oQoEu-1gk18",
  interactionStatistic: {
    "@type": "InteractionCounter",
    interactionType: { "@type": "WatchAction" },
    userInteractionCount: 57421,
  },
};

export const guidebookRichSearch = { videoRichSearch };
